import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';
import InternationalsContent from '../../components/Pages/Internationals';

export default function Pages(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: International list`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <InternationalsContent />
    </Layout>
  );
}
